import { DamageTypeEnum, FgDamageLevelEnum } from "@gtpl/shared-models/warehouse-management";
import {BaseEntity,Column,Entity,PrimaryColumn,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity ('fg_damages')

export class fgDamagesEntity{
    @PrimaryGeneratedColumn("increment",{name:'fg_damage_id'})
    fgDamageId:number;

    @Column("int",{
        name:"location_id",
        nullable:false
      })
      LocationId:number;

      @Column("int",{
        name:"sale_order_id",
        nullable:false
      })
      saleOrderId:number;

      @Column("int",{
        name:"sale_order_item_id",
        nullable:false
      })
      saleOrderItemId:number;

      @Column("int",{
        name:"stock_id",
        nullable:false
      })
      stockId:number;

      @Column("enum",{
        name:'damage_level',
        enum:FgDamageLevelEnum
      })
      damageLevel:FgDamageLevelEnum

    @Column("enum",{
        name:"damage_type",
        enum:DamageTypeEnum
      })
      damageType:DamageTypeEnum;

      @Column("int",{
        name:'no_of_cartons',
        nullable:false  
      })
      noOfCartons:number

      @Column("int",{
        name:'damage_by',
        nullable:false
      })
      damageBy:number

      @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
      })
      isActive: boolean;
    
      @CreateDateColumn({
        name: "created_at",
        type: "datetime",
        nullable: false
      })
      createdAt: Date;
    
      @Column("varchar", {
        nullable: false,
        default: 1,
        name: "created_user",
        length: 100
    
      })
      createdUser: string | null;
    
    
      @UpdateDateColumn({
        name: "updated_at",
        nullable: true,
        type: 'datetime'
      })
      updatedAt: Date;
    
      @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 100
      })
      updatedUser: string | null;
    
      @Column("int", {
        nullable: false,
        name: "unit_id"
      })
      unitId: number;
      
      @VersionColumn({
        default: 1,
        name: "version_flag"
      })
      versionFlag: number;

      @Column("varchar", {
        nullable: true,
        name: "damage_reason",
        length: 100
      })
      damageReason: string;
    
    
}

